import React from 'react'
import { ModalComponentProps } from 'modals'
import { Modal, type ModalProps } from 'components/feedback'

// ATTN this file is required only for typechecking
const CommonModal: React.FC<ModalComponentProps & ModalProps> = Modal


export default CommonModal
